const LightBackground = () => (
  <>
    <div style={{ zIndex: -2 }} className='absolute inset-0 bg-home-light-vertical 2xl:bg-home-light bg-bottom bg-no-repeat bg-cover' />
    <div style={{ zIndex: -1 }} className='absolute bottom-0 left-0 right-0 h-[50px] bg-home-light-vertical-bottom 2xl:bg-home-light bg-bottom bg-no-repeat bg-cover bg-center' />
  </>)

export default LightBackground
